export default __webpack_public_path__ + "static/media/Ellipse 12.56e819e5.png";